import React from 'react';
import {
  useSelector,
} from 'react-redux';
import {
  useField,
  Field,
  FieldProps,
} from 'formik';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { useIntl } from 'react-intl';
import styles from './index.scss';
import messages from './intl';
import Toggle from '../../toggle';

const RecipientOrder = () => {
  const intl = useIntl();
  const isSendingTemplate = useSelector(selectors.isSendingTemplate);
  const allowRecipientOrder = useSelector(selectors.allowRecipientOrder);

  const [recipientField] = useField<types.Recipient[]>('recipients');

  if (!allowRecipientOrder || recipientField.value.length <= 1) {
    return null;
  }

  return (
    <div className={styles.signerOptionsContainer}>
      <label className={styles.ssToggleLabel}>
        <Field name="recipientOrder">
          {({ field, form }: FieldProps<boolean>) => (
            <Toggle
              id="recipients-fields-order"
              indeterminate={false}
              checked={field.value}
              disabled={isSendingTemplate}
              className={styles.ssToggle}
              onChange={() => {
                form.setFieldValue(field.name, !field.value);
              }}
              data-qa-ref="recipients.fields.order" />
          )}
        </Field>
        <div className={styles.ssLabelText}>{intl.formatMessage(messages.setOrderCheckbox)}</div>
      </label>
    </div>
  );
};
export default RecipientOrder;
